import { Alert, Button, Checkbox, Col, Form, Input, Radio, Row } from "antd";
import React from "react";
import { otherFormsOfViolence, typeOfSexualViolence } from "../../../constants/incident.constant";
import 'antd/dist/reset.css';
import { getMappedData } from "../util";

export default function ConcordanceCard() {
  return (
    <>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={24}>
        <Alert
          message='Concordance Cards "Participate in Community in Leadership Project"'
          description="Explain again that Survivors may voluntarily choose to enter the Community in Leadership Project, and may also choose to no longer be active, at any time"
          type="info"
        />
        </Col>
      </Row>
      <Row gutter={[24, 0]} style={{marginTop: '20px'}}>
        <Col xs={24} xl={24}>
          <Form.Item
            label={getMappedData('concordance_ack_1')}
            name="concordance_ack_1"
            rules={[{ required: true, message: "Please select an option!" }]}
          >
            <Radio.Group>
              <Radio.Button value="yes">Yes</Radio.Button>
              <Radio.Button value="no">No</Radio.Button>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={24}>
          <Form.Item
            label={getMappedData('concordance_ack_2')}
            name="concordance_ack_2"
            rules={[{ required: true, message: "Please select an option!" }]}
          >
            <Radio.Group>
              <Radio.Button value="yes">Yes</Radio.Button>
              <Radio.Button value="no">No</Radio.Button>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[24, 0]}>
        <Col xs={24} xl={24}>
          <Form.Item
            label={getMappedData('concordance_ack_3')}
            name="concordance_ack_3"
            rules={[{ required: true, message: 'Please select at least one option!' }]}
          >
            <Checkbox.Group style={{flexDirection: 'column', paddingLeft: '10px'}}>
              <Checkbox value="concordance_ack_3_value_1">{getMappedData('concordance_ack_3_value_1')}</Checkbox>
              <Checkbox value="concordance_ack_3_value_2">{getMappedData('concordance_ack_3_value_2')}</Checkbox>
              <Checkbox value="concordance_ack_3_value_3">{getMappedData('concordance_ack_3_value_3')}</Checkbox>
            </Checkbox.Group>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}
